export const ONE_SEC_IN_MS = 1000;

export const EMBED_NOTIFICATION_DELAY_IN_MS = 300000;
